import * as React from 'react'
import * as classNames from 'classnames'

const IconArrowLeft = (props: { className?: string }) => {
  const classnames = classNames(`icon`, props.className)
  return (
    <svg
      className={classnames}
      fill='#dcdcdc'
      width='7'
      height='12'
      viewBox='0 0 7 12'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path fillRule='evenodd' clipRule='evenodd' d='M7 1.4L2.64865 6L7 10.6L5.67568 12L0 6L5.67568 0L7 1.4Z' />
    </svg>
  )
}

export default IconArrowLeft



// WEBPACK FOOTER //
// ./src/components/icons/ui/IconArrowLeft.tsx